import { i18n, Messages } from '@lingui/core';

const SUPPORTED_LOCALES = ['en', 'es', 'zh']; 
const DEFAULT_LOCALE = 'en';

export const setLanguage = (requestedLanguage: string): Promise<void> => {
  const baseLocale = requestedLanguage.split('-')[0];
  const language = SUPPORTED_LOCALES.includes(baseLocale) ? baseLocale : DEFAULT_LOCALE;

  return import(`../locales/${language}/${language}.js`) 
    .then(({ messages }: { messages: Messages }) => {
      i18n.load(language, messages);
      i18n.activate(language);
    })
    .catch(() => {
      throw new Error(`Error: There has been an error loading ${language} language`);
    });
};